module.exports = __webpack_public_path__ + "img/coordinate_big@3x.b0d09da2.png";